module.exports = __webpack_public_path__ + "static/img/badge-larvicide-inactive.4b4bc51.svg";